import SuccessFeedbackWithConfettiBurst from 'components/molecules/SuccessFeedbackWithConfettiBurst.component';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { redirectMobileAutoLoginURL } from 'utils/constants';

const MobileAppLoginRedirection = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const id = setTimeout(() => {
      window.location.href = redirectMobileAutoLoginURL;
    }, 5000);

    return () => clearTimeout(id);
  }, []);

  return (
    <SuccessFeedbackWithConfettiBurst
      message={t('mobile_login_redirection.success_msg')}
    />
  );
};

export default MobileAppLoginRedirection;
